import './CharacterSet.scss';

import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  image: {
    url: string | null;
    width: number | null;
    height: number | null;
  };
}

const CharacterSet: FC<Props> = (props) => {
  const { image } = props;

  const { t } = useTranslation();

  if (image.url == null) {
    return null;
  }

  return (
    <div className="content-wrapper">
      <div className="FamiliesCharacterSet">
        <h2>{t('family.characterSet')}</h2>

        <img
          className="FamiliesCharacterSet-image"
          src={image.url}
          width={image.width ?? undefined}
          height={image.height ?? undefined}
          loading="lazy"
          decoding="async"
        />
      </div>
    </div>
  );
};

export default CharacterSet;
